"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodashEs = require("lodash-es");
var _Text = _interopRequireDefault(require("../../../Text"));
var Styled = _interopRequireWildcard(require("./index.styled"));
var _jsxRuntime = require("react/jsx-runtime");
const SpecHighlightV3 = function (props) {
  const {
    description,
    label,
    value,
    id,
    className
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.Container, {
    id: id,
    className: className,
    "data-testid": "SpecHighlightV3",
    children: [!(0, _lodashEs.isEmpty)((0, _lodashEs.trim)(value)) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.Value, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
        children: value
      })
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {}), !(0, _lodashEs.isEmpty)((0, _lodashEs.trim)(description)) || !(0, _lodashEs.isEmpty)((0, _lodashEs.trim)(label)) ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.Wrapper, {
      children: [!(0, _lodashEs.isEmpty)((0, _lodashEs.trim)(label)) && /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.Label, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
          children: label
        })
      }), !(0, _lodashEs.isEmpty)((0, _lodashEs.trim)(description)) && /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.Description, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
          children: description
        })
      })]
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {})]
  });
};
var _default = exports.default = SpecHighlightV3;